import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  // GET DESTINATIONS
  destinationsLoading: false,
  destinations: [],
  destinationsError: null,

  // GET DESTINATIONS BY DATE
  destinationsByDateLoading: false,
  destinationsByDate: [],
  destinationsByDateError: null,

  // CREATE DESTINATION
  createDestinationLoading: false,
  createDestinationError: null,
};

export const destinationSlice = createSlice({
  name: "destination",
  initialState,
  reducers: {
    resetState: (state) => {
      state.destinationsLoading = false;
      state.destinations = [];
      state.destinationsError = null;
    },

    // GET DESTINATIONS
    destinationsFetch: (state) => {
      state.destinationsLoading = true;
      state.destinations = [];
      state.destinationsError = null;
    },
    destinationsSuccess: (state, action) => {
      state.destinationsLoading = false;
      state.destinations = action.payload;
      state.destinationsError = null;
    },
    destinationsError: (state, action) => {
      state.destinationsLoading = false;
      state.destinations = [];
      state.destinationsError = action.payload;
    },

    // GET DESTINATIONS BY DATE
    destinationsByDateFetch: (state) => {
      state.destinationsByDateLoading = true;
      state.destinationsByDate = [];
      state.destinationsByDateError = null;
    },
    destinationsByDateSuccess: (state, action) => {
      state.destinationsByDateLoading = false;
      state.destinationsByDate = action.payload;
      state.destinationsByDateError = null;
    },
    destinationsByDateError: (state, action) => {
      state.destinationsByDateLoading = false;
      state.destinationsByDate = [];
      state.destinationsByDateError = action.payload;
    },

    // CREATE DESTINATION
    createDestinationsPost: (state) => {
      state.createDestinationLoading = true;
      state.createDestinationError = null;
    },
    createDestinationsSuccess: (state, action) => {
      state.createDestinationLoading = false;
      state.destinations = [...state.destinations, action.payload];
      state.createDestinationError = null;
    },
    createDestinationsError: (state, action) => {
      state.createDestinationLoading = false;
      state.createDestinationError = action.payload;
    },
  },
});

export const destinationActions = destinationSlice.actions;
export const destinationReducers = destinationSlice.reducer;
